module.exports = __webpack_public_path__ + "static/media/6BIANCA_Official_MENU-20537.26955441.jpg";